import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { useNavigate, useParams } from "react-router-dom";
import {
  editNetaVideos,
  netaVideosDetails,
} from "../../../store/API/MemberApis";
import {
  getDistrictList,
  getDivisionList,
  getSeatList,
  getUpazilaList,
} from "../../../store/apis";
import NetaVideosCreateForm from "../../../components/Admin/NetaVideos/NetaVideosCreateForm";

const NetaVideosEdit = () => {
  const { netaVideoDetails } = useAppSelector((state) => state.member);
  let { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (id) dispatch(netaVideosDetails(id));
  }, [dispatch, id]);
  useEffect(() => {
    dispatch(getDivisionList());
    dispatch(getDistrictList());
    dispatch(getUpazilaList());
    dispatch(getSeatList());
  }, [dispatch]);
  console.log(netaVideoDetails, "netaVideoDetails");
  const handleSubmit = async (
    formData: any,
    memberData: any,
    videoTypeData: any,
    thumbnail: File | null
  ) => {
    const formDataToSubmit = new FormData();
    // Append all the form data (text inputs) to FormData
    Object.keys(formData).forEach((key) => {
      const value = formData[key as keyof typeof formData];
      if (value !== null && value !== undefined && value !== "") {
        formDataToSubmit.append(key, value);
      }
    });
    // Append thumbnail as a file (only if a file was selected)
    if (thumbnail) {
      formDataToSubmit.append("thumbnail", thumbnail);
    }
    if (memberData) {
      formDataToSubmit.append("member_id", memberData.value.toString());
    }
    if (videoTypeData) {
      formDataToSubmit.append("videoType", videoTypeData.label.toString());
    }
    // Dispatch the createNeta action with the FormData
    dispatch(editNetaVideos({ formData: formDataToSubmit, navigate, id }));
  };

  return (
    <div className="flex flex-col gap-4 px-4 pt-6 text-start justify-center">
      <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-gray-800 w-full">
        <div className="border-b border-stroke py-4 px-6 dark:border-strokedark">
          <h3 className="font-semibold text-black dark:text-white">
            Edit Neta Videos
          </h3>
        </div>
        <NetaVideosCreateForm
          onSubmit={handleSubmit}
          details={netaVideoDetails!}
        />
      </div>
    </div>
  );
};

export default NetaVideosEdit;
